export interface DtacBase {
  "@id": string;
  "@type": string;
};

export const REF_TEMPLATE: DtacBase = {
  '@id': '',
  '@type': ''
};
